module.exports = __webpack_public_path__ + "media/images/redesign-images/promotions/promos-08-e70944b87485fa5bf0f5705276a3584e.jpg";